import { Box, Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import styles from '../styles';
import { useState, useMemo } from 'react';
import debounce from 'lodash/debounce';

function MobileCuttingsInput({ data, columns, updateData, loading }) {
  const classes = styles();
  const [isFocused, setIsFocused] = useState(null);
  const [editBuffer, setEditBuffer] = useState({});

  const debouncedUpdate = useMemo(
    () =>
      debounce((id, field, value) => {
        if (
          value !== '' &&
          value !== null &&
          value !== undefined &&
          !isNaN(Number(value)) &&
          value !== '.' &&
          value !== '-'
        ) {
          updateData(id, field, Number(value));
        } else {
          updateData(id, field, value);
        }
      }, 1000),
    [updateData]
  );

  const handleChange = (event, { id, field }) => {
    event.stopPropagation();
    event.preventDefault();
    const newValue = event.target.value;

    const isValidPartial = /^-?\d*\.?\d*$/.test(newValue);
    if (!isValidPartial) return;

    const key = `${id}-${field}`;

    setEditBuffer((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    debouncedUpdate(id, field, newValue);
  };

  const handleBlur = (row, field) => {
    const key = `${row._id}-${field}`;
    const raw = editBuffer[key] ?? row[field];

    setIsFocused(null);

    debouncedUpdate.flush();

    if (
      raw !== '' &&
      raw !== null &&
      raw !== undefined &&
      !isNaN(Number(raw)) &&
      raw !== '.' &&
      raw !== '-'
    ) {
      updateData(row._id, field, Number(raw));
    } else {
      updateData(row._id, field, raw);
    }

    setEditBuffer((prev) => {
      const rest = { ...prev };
      delete rest[key];
      return rest;
    });
  };

  return (
    <>
      {data.map((row, index) => (
        <Box key={index} className={classes.gridContainer}>
          {columns.map((col) => {
            if (col?.hide) return null;
            const key = `${row._id}-${col.field}`;
            const rawValue = editBuffer[key] ?? row[col.field] ?? '';

            const displayValue =
              isFocused === key
                ? rawValue
                : col.valueFormatter
                  ? col.valueFormatter({
                    row,
                    field: col.field,
                    value: row[col.field],
                  })
                  : row[col.field] ?? '';

            return (
              <Grid container key={col.field} className={classes.gridItem}>
                <Typography
                  className={classes.headerName}
                  variant="body1"
                  sx={{ pt: '5px', alignSelf: 'center' }}
                >
                  {col.headerName}
                </Typography>

                <TextField
                  disabled={loading}
                  variant="filled"
                  sx={{
                    flex: 0.5,
                    p: 0,
                    m: 0,
                    '.MuiInputBase-input': {
                      padding: '10px',
                      textAlign: 'center',
                      fontWeight: 900
                    },
                  }}
                  value={displayValue}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  onChange={(event) =>
                    handleChange(event, {
                      id: row._id,
                      field: col.field,
                    })
                  }
                  onFocus={() => setIsFocused(key)}
                  onBlur={() => handleBlur(row, col.field)}
                />
              </Grid>
            );
          })}
        </Box>
      ))}
    </>
  );
}

MobileCuttingsInput.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  updateData: PropTypes.func,
  loading: PropTypes.bool,
};

export default MobileCuttingsInput;
